import assessmentReader from '../../store/readHelpers/AssessmentReader';
import settingsReader from '../../store/readHelpers/SettingsReader';

const scorableItemReader = {
    getScorableItemByNumber(scorableItemNumber) {
        const questionNumbering = this.getQuestionNumberingState();
        if (questionNumbering === undefined || !Array.isArray(questionNumbering.scorableItems)) {
            return undefined;
        }

        return questionNumbering.scorableItems.find((item) => {
            return item.orderNumber === scorableItemNumber;
        });
    },

    getScorableItemByContentRevisionId(contentRevisionId) {
        const questionNumbering = this.getQuestionNumberingState();
        if (questionNumbering === undefined || !Array.isArray(questionNumbering.scorableItems)) {
            return undefined;
        }

        return questionNumbering.scorableItems.find((item) => {
            return item.contentRevisionId === contentRevisionId;
        });
    },

    getQuestionNumberingState() {
        return assessmentReader.getAssessment().questionNumbering;
    },

    getScorableItems() {
        const questionNumbering = this.getQuestionNumberingState();
        if (questionNumbering === undefined || !Array.isArray(questionNumbering.scorableItems)) {
            return undefined;
        }

        return questionNumbering.scorableItems.sort((item, nextItem) => {
            return item.orderNumber - nextItem.orderNumber;
        });
    },

    getScorableItemsInQuestion(contentRevisionId, allScorableItems = this.getScorableItems()) {
        if (!Array.isArray(allScorableItems)) {
            return [];
        }

        return allScorableItems.filter(item => item.contentRevisionId === contentRevisionId);
    },

    getScorableItemsInInteraction(contentRevisionId, responseIdentifier) {
        return this.getScorableItemsInQuestion(contentRevisionId).filter((item) => {
            return item.responseIdentifier === responseIdentifier;
        });
    },

    getScorableItemsInInteractionWithChoice(contentRevisionId, responseIdentifier, choiceIdentifier) {
        return this.getScorableItemsInQuestion(contentRevisionId).filter((item) => {
            return item.responseIdentifier === responseIdentifier && item.choiceIdentifier === choiceIdentifier;
        });
    },

    useNumberPerInteraction() {
        const questionNumbering = this.getQuestionNumberingState();
        return settingsReader.useNumberingPerScorableItem()
            && typeof questionNumbering !== 'undefined'
            && Array.isArray(questionNumbering.scorableItems);
    },
};

export default scorableItemReader;
